const stMob = {
  containBttSettings: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    backgroundColor: '#f6f6f6',
    borderRadius: '8px',
    padding: '5px 3px',
    marginBottom: '7px',
  },
  containHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'auto',
    width: 'auto',
    padding: '5px',
  },
  titleBtt: {
    fontSize: '18px',
  },
  labelbtt: {
    fontSize: '14px',
    color: 'gray',
  },
}

export { stMob }
